export default __webpack_public_path__ + "static/media/refercode_mobile.7b426a7a.png";